import {
  performanceComparisonResponseSchema,
  type PerformanceComparisonResponse,
} from '@/features/benchmarking/schemas/benchmarkingPerformanceComparison';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export type GetBenchmarkingPerformanceComparisonParams = { escolaId: number };

export const getBenchmarkingPerformanceComparison = httpGetAdapter<
  PerformanceComparisonResponse,
  GetBenchmarkingPerformanceComparisonParams
>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/comparativo-desempenho`,
  schema: performanceComparisonResponseSchema,
});
